'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');
var style = require('../utils/style.js');
var Tag = require('./Tag.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

/**
 * This file is based off packages/nth-kit-returns-headless/src/components/SelectItem/index.tsx
 */

// Outline is used to show the selected state. Using an outline
// in addition to the border allows us to show selected / unselected
// without any content moving around.
const SelectCardRoot = styled__default["default"].div.withConfig({
  componentId: "sc-1crhwyi-0"
})(["box-sizing:border-box;border:0 none;padding:16px;background-color:inherit;font-family:inherit;font-weight:inherit;color:inherit;text-align:left;width:100%;border-radius:4px;", " margin:0;outline-width:", ";outline-style:solid;outline-offset:-2px;outline-color:transparent;", ""], _ref => {
  let {
    sDefault
  } = _ref;
  return sDefault;
}, _ref2 => {
  let {
    sDefault
  } = _ref2;
  return style.getBorderWidth(sDefault);
}, _ref3 => {
  let {
    selected,
    sActive
  } = _ref3;
  return selected && sActive;
});

/**
 * The interactive card can be manually marked as focused with a prop
 * or it can by default respond to a focus event.
 */
const SelectCardInteractive = styled__default["default"](SelectCardRoot).withConfig({
  componentId: "sc-1crhwyi-1"
})(["cursor:pointer;&:hover,&:focus{border-color:", ";background-color:", ";filter:", ";}", ""], _ref4 => {
  let {
    sActive
  } = _ref4;
  return sActive === null || sActive === void 0 ? void 0 : sActive.borderColor;
}, _ref5 => {
  let {
    sDefault
  } = _ref5;
  return sDefault === null || sDefault === void 0 ? void 0 : sDefault.backgroundColor;
}, _ref6 => {
  let {
    sDefault
  } = _ref6;
  return sDefault !== null && sDefault !== void 0 && sDefault.backgroundColor ? 'brightness(95%)' : undefined;
}, _ref7 => {
  let {
    focused,
    sDefault,
    sActive
  } = _ref7;
  return focused && {
    borderColor: sActive === null || sActive === void 0 ? void 0 : sActive.borderColor,
    backgroundColor: sDefault === null || sDefault === void 0 ? void 0 : sDefault.backgroundColor,
    filter: sDefault !== null && sDefault !== void 0 && sDefault.backgroundColor ? 'brightness(95%)' : undefined
  };
});
const SelectItem = _ref8 => {
  let {
    as,
    tagProps,
    readOnly,
    onClick,
    ...props
  } = _ref8;
  const {
    buttonsPrimaryDefault,
    documentbodyNoneNone,
    bodytextDefaultNone,
    panelcontainerNoneNone,
    selecteditemNoneNone
  } = nthHookTheme.useTheme();
  const SelectCardStyled = readOnly ? SelectCardRoot : SelectCardInteractive;
  const selectableCard = /*#__PURE__*/React__default["default"].createElement(SelectCardStyled, _extends__default["default"]({
    sDefault: {
      ...bodytextDefaultNone,
      ...panelcontainerNoneNone,
      backgroundColor: (documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor) ?? (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.backgroundColor)
    },
    sActive: {
      borderColor: style.getBorderColor(selecteditemNoneNone),
      outlineColor: style.getBorderColor(selecteditemNoneNone),
      ...((tagProps === null || tagProps === void 0 ? void 0 : tagProps.tagContent) && {
        borderTopLeftRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3
      })
    },
    onClick: readOnly ? undefined : onClick,
    as: as ?? readOnly ? 'div' : 'button',
    style: {
      // used for container queries of the item card
      containerType: 'inline-size'
    }
  }, props));
  return tagProps !== null && tagProps !== void 0 && tagProps.tagContent ? /*#__PURE__*/React__default["default"].createElement(Tag["default"], _extends__default["default"]({
    s: {
      ...selecteditemNoneNone,
      borderRadius: 0,
      borderTopLeftRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3,
      borderBottomRightRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3,
      backgroundColor: style.getBorderColor(selecteditemNoneNone) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor)
    }
  }, tagProps), selectableCard) : selectableCard;
};
var SelectableCard = nthHookTheme.withThemeProvider(SelectItem, {
  themeTokens: ['buttonsPrimaryDefault', 'documentbodyNoneNone', 'bodytextDefaultNone', 'panelcontainerNoneNone', 'selecteditemNoneNone']
});

exports["default"] = SelectableCard;
